<ds-card
  class="pi-requisitos-card"
  background="#ffffff"
  shadow="l2"
  gap="24px">
  <div class="pi-requisitos__header">
    <ds-icon
      class="pi-requisitos__header-icon"
      name="CheckCircle"
      size="32px"
      aria-hidden="true">
    </ds-icon>
    <h2 class="pi-requisitos__title">¿Qué necesitas para realizar tu solicitud?</h2>
  </div>

  <div class="pi-requisitos__panel">
    <div class="pi-requisitos__col">
      <app-pi-requirement-item title="Cumplir el requisito de edad" tone="success">
        Ser menor de 65 años, tanto para mujeres como para hombres.
      </app-pi-requirement-item>

      <app-pi-requirement-item
        title="Adjuntar tus certificados y los de tus beneficiarios"
        tone="success">
        <ul>
          <li>Copia de tu cédula de identidad</li>
          <li>Certificado de Nacimiento (tuyo y de tus beneficiarios).</li>
          <li>Certificado de Matrimonio, si corresponde.</li>
          <li>Certificado de Nacimiento del Cónyuge, si corresponde.</li>
          <li>Certificado de Unión Civil, si corresponde.</li>
        </ul>
      </app-pi-requirement-item>
    </div>

    <div class="pi-requisitos__divider" aria-hidden="true"></div>

    <div class="pi-requisitos__col">
      <app-pi-requirement-item title="No estar pensionado" tone="success">
        Debes ser un afiliado activo.
      </app-pi-requirement-item>

      <app-pi-requirement-item title="Tener a mano tu licencia médica, si aplica" tone="success">
        Te pediremos algunos datos que aparecen en el documento.
      </app-pi-requirement-item>

      <app-pi-requirement-item title="Compartir otros documentos" tone="success">
        <ul>
          <li>Certificado de Leyes Especiales, si eres empleado público.</li>
          <li>Certificado Médico, en caso que no puedas comparecer en la Comisión.</li>
          <li>Antecedentes médicos, opcional.</li>
        </ul>
      </app-pi-requirement-item>
    </div>
  </div>

  <app-pi-info-alert title="¿Te faltan documentos?">
    <span class="pi-requisitos__alert-text"
      >Puedes descargarlos en
      <a
        class="pi-requisitos__external-link"
        href="https://www.registrocivil.cl/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Ir a www.registrocivil.cl, se abre en una nueva pestaña"
        (click)="abrirRegistroCivil($event)"
        >www.registrocivil.cl</a
      >.</span
    >
  </app-pi-info-alert>
</ds-card>
